<script lang="ts" setup>
import debounce from "lodash.debounce";
const documentId = inject("documentId") as any;
const submittedDocumentStore = useSubmittedDocumentStore(documentId);
const { studentNote } = storeToRefs(submittedDocumentStore);

const onUpdate = () => {
  saveDebounced();
};

const save = async () => {
  if (studentNote.value == undefined) return;

  await studentNote.value.save();
};

const saveDebounced = debounce(save, 400);
</script>

<template>
  <div v-if="studentNote">
    <h2 class="text-h5 mb-2">Memo</h2>
    <BaseTextArea
      class="mb-2 w-full h-[200px] text-[13px]"
      v-model="studentNote.notes"
      @update:model-value="onUpdate"
    />
  </div>
</template>

<style scoped></style>
